import tw from "twin.macro";

export const Header = tw.div`
	flex w-full justify-between
`;
export const SearchAndFiltersWrapper = tw.div`flex gap-8`;
export const NoGrowWrapper = tw.div`grow-0 lg:w-[11rem]`;
export const SearchBarWrapper = tw.div``;
